import { Dialog, DialogContent } from "@/components/ui/dialog";

const MediaPreviewDialog = ({ previewFile, onClose }) => {
  return (
    <Dialog open={!!previewFile} onOpenChange={onClose}>
      <DialogContent className="max-w-[40vw] max-h-[70vh] flex items-center justify-center bg-black">
        {previewFile?.isImage && (
          <img
            src={previewFile?.previewUrl}
            alt="Preview"
            className="max-w-full max-h-[60vh] rounded-lg object-cover"
          />
        )}
        {previewFile?.isVideo && (
          <video
            src={previewFile?.previewUrl}
            controls
            autoPlay
            className="max-w-full max-h-[60vh] rounded-lg"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MediaPreviewDialog;
